import * as React from 'react';
import {MobileMenuProps, MobileMenuState} from '../types/components';
import AssetsManager from '../utils/AssetsManager';
import Assistant from './Assistant';
import Button from './Button';
import {CSSTransition} from 'react-transition-group';

class MobileMenu extends React.Component<MobileMenuProps, MobileMenuState> {

    constructor(props) {
        super(props);
        this.state = {
            showMenu: false
        };
    }

    toggleMenu = () => {
        this.setState({showMenu: !this.state.showMenu});
    }

    render() {
        const {assistantInformation, onPressModalAssistant, onClickLogout} = this.props;
        const {showMenu} = this.state;
        return (
            <div className="row d-block d-sm-none d-sm-block d-md-none" onClick={this.toggleMenu}>
                <div className="col">
                    <div className="mobile-menu" onClick={this.toggleMenu}>
                        {assistantInformation && <div className="budge-mobile-menu"/>}
                        <img alt="menu" src={AssetsManager(
                            '/assets/images/common/hamburger-icon.svg'
                        )}/>
                    </div>
                    <div className="wrapper-content-mobile-menu">
                        <CSSTransition in={showMenu} timeout={200} unmountOnExit classNames="fade">
                            <div className="content-mobile-menu">
                                <div className="wrapper-logout">
                                    <Button onPress={onClickLogout}
                                            type="circle-small-outlined"
                                            customClass="ml-auto mr-auto"
                                            icon="/assets/images/common/close-session-icon.svg"/>
                                </div>
                            </div>
                        </CSSTransition>
                    </div>
                </div>
            </div>
        );
    }
}

export default MobileMenu;
